import styled from 'styled-components';

export const TableList = styled.div`
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: flex-start;
    padding: 0 50px;
    flex-wrap: wrap;
`;

export const FindTables = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    padding: 50px 0 0 50px;
`;

export const HubStatus = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    padding: 50px 50px 0;
`;

export const Title = styled.h2`
    font-size: 18px;
    color: rgba(255,255,255, 0.5);
    margin-right: 20px;
    text-transform: uppercase;
    font-weight: 100;
`;

export const TableItemNew = styled.div`
    font-size: 14px;
    transition: all .3s ease 0s;
    text-transform: uppercase;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 76px;
`;

export const TableItemNewTitle = styled.div`
    font-size: 14px;
    transition: all .3s ease 0s;
    text-transform: uppercase;
    margin-bottom: 10px;
    color: #fff;
`;

export const TableItemNewLabel = styled.div`
    font-size: 12px;
    color: #999;
`;

export const TableItemNewData = styled.input`
    width: 0;
    flex: 1;
    background-color: transparent;
    border: 1px solid #666;
    height: 40px;
    color: #fff;
    padding-left: 5px;

    :focus {
        outline-color: rgba(255,266,266, 0.4);
    }
`;

export const TableItemNewInput = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;
    width: 100%;
`;

export const TableItemNewOK = styled.div`
    width: 40px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-left: 10px;
    height: 40px;
    color: ${props => props.theme.colors.confirm};
    transition: all .3s ease 0s;

    :hover {
        background-color: ${props => props.theme.colors.confirm};
        color: #000;
    }
`;
export const TableItemNewCancel = styled.div`
    width: 40px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-left: 10px;
    height: 40px;
    color: ${props => props.theme.colors.cancel};
    transition: all .3s ease 0s;

    :hover {
        background-color: ${props => props.theme.colors.cancel};
        color: #000;
    }
`;

export const TableItemCell = styled.div`
    width: calc(33.33333% - 14px);
    border: 1px solid #999;
    margin: 0 20px 20px 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    box-sizing: border-box;
    padding: 20px;
    transition: all .3s ease 0s, margin-right 0s linear 0s;
    position: relative;
    min-height: 116px;
    color: #fff;

    &.noBorder {
        border-width: 0;
    }

    &:nth-child(3n) {
        margin-right: 0;
    }

    :not(.noBorder) {
        cursor: pointer;
    }

    :not(.noBorder):hover {
        border: 1px solid ${props => props.theme.colors.main};
    }

    :not(.noBorder):hover .text,
    :not(.noBorder):hover ${TableItemNew} {
        color: ${props => props.theme.colors.main};
    }
`;

export const NoTable = styled.div`
    width: calc(33.33333% - 14px);
    border: 1px dashed #999;
    margin: 0 20px 20px 0;
    padding: 20px;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    transition: all .3s ease 0s;
    min-height: 116px;
    color: #888;

    &:before {
        font-family: 'Material Design Icons';
        font-size: 50px;
        color: #888;
        content: '\\F1201';
        margin-right: 10px;
    }
`;

export const TableItemSideAdd = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: calc(50% + 10px);
    border: 1px solid #999;
    text-align: center;
    padding: 0 10px;
    height: 116px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    transition: border-color .3s ease 0s;
    cursor: pointer;

    :hover {
        border: 1px solid ${props => props.theme.colors.main};
        color: ${props => props.theme.colors.main};
    }
`;

export const TableItemSideJoin = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: calc(50% + 10px);
    border: 1px solid #999;
    text-align: center;
    padding: 0 10px;
    height: 116px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    transition: border-color .3s ease 0s;
    cursor: pointer;

    :hover {
        border: 1px solid ${props => props.theme.colors.main};
        color: ${props => props.theme.colors.main};
    }
`;

export const TableItemTemplates = styled.div`
    font-size: 14px;
    transition: all .3s ease 0s;
    text-transform: uppercase;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 76px;
`;

export const TableItemSideTemplates = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: calc(50% + 10px);
    border: 1px solid #999;
    text-align: center;
    padding: 0 10px;
    height: 116px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    transition: border-color .3s ease 0s;
    cursor: pointer;

    :hover {
        border: 1px solid ${props => props.theme.colors.main};
        color: ${props => props.theme.colors.main};
    }
`;

export const ButtonIcon = styled.div`
    border: 1px solid ${props => props.color};
    color: ${props => props.color};
    width: 25px;
    height: 25px;
    min-width: 25px;
    min-height: 25px;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: color .3s ease 0s, background-color .3s ease 0s;

    :hover {
        color: ${props => props.hoverColor || '#fff' };
        background-color: ${props => props.color};
    }

    &:not(:last-child) {
        margin-right: 10px;
    }
    
    &:before {
        transition: color .4s ease 0s;
        content: '${props => props.icon}';
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: 'Material Design Icons';
        font-size: 16px;
        color: ${props => props.color};
    }

    &:hover:before {
        color: #000;
    }
`;

export const Row = styled.div`
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: stretch;
`;

export const HeaderRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 50px;
`;

export const NotificationError = styled.div`
    padding: 10px;
    color: #f72;
    margin: 0 50px 30px;
    box-sizing: border-box;
    background-color: #421;
    border: 1px solid #f50;
    display: flex;
    flex-direction: row;
    align-items: center;
    line-height: 20px;
    justify-content: space-between;
`;

export const Link = styled.a.attrs(() => ({
    target: "_blank"
}))`
    margin-left: 10px;
    padding-right: 10px;
    border-right: 1px solid #f50;
    color: #fff;
    font-weight: 700;
    text-decoration: none;
    white-space: nowrap;
`;

export const Action = styled.a`
    margin-left: 10px;
    cursor: pointer;
`;


export const StatusRow = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: center;
    justify-content: stretch;
    margin: 10px 0 15px;
    padding: 3px;
    
    &:first-child {
        margin-top: 20px;
    }
    
    &:last-child {
        margin-bottom: 0;
    }
`;

export const StatusLink = styled.a.attrs(p => ({
    target: '_blank',
}))`
    width: auto;
    text-align: right;
    text-decoration: none;
    font-weight: 400;
    color: ${p => p.color ?? '#fff'};

    &:hover {
        font-weight: 900;
    }
`;

export const StatusLabel = styled.div`
    flex: 1;
    color: ${props => props.color ?? '#fff'};
    font-size: 14px;
    line-height: 20px;
`;

export const StatusIcon = styled.div`
    color: ${props => props.color ?? '#fff'};
    width: 30px;
    height: 40px;
    min-width: 30px;
    min-height: 40px;
    margin-right: 5px;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    
    &:before {
        content: '${props => props.icon}';
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: 'Material Design Icons';
        font-size: 24px;
        color: ${props => props.color ?? '#fff'};
    }

    &.pulse:after {
        content: '${props => props.icon}';
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: 'Material Design Icons';
        font-size: 24px;
        color: ${props => props.color ?? '#fff'};
        animation: pulse-icon 2s linear forwards infinite;
    }
`;

export const TablesCounter = styled.div`
    font-size: 12px;
    color: #777;
`;

export const Button = styled.a.attrs(p => ({
    target: '_blank',
}))`
    border: 1px solid ${props => props.color ?? '#fff'};
    color: ${props => props.color ?? '#fff'};
    width: 120px;
    height: 30px;
    min-width: 120px;
    min-height: 30px;
    margin-left: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: color .3s ease 0s, background-color .3s ease 0s;

    :hover {
        color: ${props => props.hoverColor ?? '#000' };
        background-color: ${props => props.color ?? '#fff'};
    }

    &.full {
        width: 100%;
        margin-left: 0;
    }
`;
